export default __webpack_public_path__ + "static/media/Individual.834bc778.png";